const uris = {
  configBaseUrl:
    window.runConfig.configBaseUrl +
    (window.runConfig.configBaseUrl[
      window.runConfig.configBaseUrl.length - 1
    ] === '/'
      ? ''
      : '/'),
  scoreBaseUrl:
    window.runConfig.scoreBaseUrl +
    (window.runConfig.scoreBaseUrl[window.runConfig.scoreBaseUrl.length - 1] ===
    '/'
      ? ''
      : '/'),
  leadBaseUrl:
    window.runConfig.leadBaseUrl +
    (window.runConfig.leadBaseUrl[window.runConfig.leadBaseUrl.length - 1] ===
    '/'
      ? ''
      : '/'),
  configFile: window.runConfig.configFile
}

export default uris
